var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000004710(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "#FDEFF3",
    stroke: "#F6BCCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12C16.92 12 12 16.92 12 23C12 29.08 16.92 34 23 34C29.08 34 34 29.08 34 23C34 16.92 29.08 12 23 12ZM28.79 20.12L22.3 27.23C22.12 27.43 21.86 27.55 21.58 27.56H21.56C21.29 27.56 21.04 27.46 20.85 27.27L17.24 23.66C16.85 23.27 16.85 22.64 17.24 22.25C17.63 21.86 18.26 21.86 18.65 22.25L21.52 25.12L27.31 18.78C27.68 18.37 28.31 18.34 28.72 18.72C29.13 19.09 29.16 19.72 28.78 20.13L28.79 20.12Z",
    fill: "#D91A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000004710);
export default __webpack_public_path__ + "static/media/Group 1000004710.ce5d5811b638735d4e1ee27b1aa7be42.svg";
export { ForwardRef as ReactComponent };